import React from "react"
import { graphql } from "gatsby"
import { Content } from "components/content/Content"
import { Coupon } from "./Coupon"
import type { CouponGroup } from "./coupons"
// import type { ReusableButtonGroup } from "_types/Button"
import "./coupons.module.scss"

interface CouponBannerProps {
  // reusable_button_group?: ReusableButtonGroup
  alt_background_color: boolean
  coupon_group: CouponGroup
  description: { data: { description: string } } | null
  eyebrow_text: string | null
  heading: string | null
  sub_heading: string | null
}

const COUPON_CLASSNAME: { [key: number]: string } = {
  1: "coupon-banner__grid--1",
  2: "coupon-banner__grid--2",
  3: "coupon-banner__grid--3",
  4: "coupon-banner__grid--4",
}

export const CouponBanner = ({
  // reusable_button_group,
  alt_background_color,
  coupon_group,
  description,
  eyebrow_text,
  heading,
  sub_heading,
}: CouponBannerProps) => {
  return (
    <section
      className={`coupon-banner
        ${
          alt_background_color
            ? "u-content-block-padding alternate-background-color"
            : "u-content-block-padding"
        }`}
    >
      <div className="fr-container fr-container--large">
        <div className={COUPON_CLASSNAME[coupon_group?.coupon_list.length]}>
          <div className="coupon-banner__info">
            <div className="text-content-block__title">
              {eyebrow_text && <p className="eyebrow-text">{eyebrow_text}</p>}
              {heading && <h2>{heading}</h2>}
              {sub_heading && <h3>{sub_heading}</h3>}
            </div>
            {description && (
              <Content
                content={description.data?.description}
                styleListsAsGrid={false}
              />
            )}
          </div>
          {coupon_group?.coupon_list &&
            coupon_group?.coupon_list.map((couponProps, index) => {
              return (
                <Coupon key={`${couponProps.id}-${index}`} {...couponProps} />
              )
            })}
        </div>
      </div>
    </section>
  )
}

export const query = graphql`
  fragment StrapiCouponBannerFragment on STRAPI__COMPONENT_CONTENT_BLOCK_COUPON_BANNER {
    strapi_component
    id
    alt_background_color
    eyebrow_text
    heading
    sub_heading
    buttons {
      ...StrapiButtonFragment
    }
    coupon_group {
      ...StrapiCouponFragment
    }
    description {
      data {
        description
      }
    }
    reusable_button_group {
      ...StrapiReusableButtonFragment
    }
  }
`
